import { Box, Link, Typography } from "@mui/material";
import { FormWrapper } from "../../components/FormWrapper/FormWrapper";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import XIcon from "@mui/icons-material/X";
import FacebookIcon from "@mui/icons-material/Facebook";

function PreRegisterInfo() {
  return (
    <FormWrapper title="Welcome" collapsible={false}>
      <Box>
        {/* <Typography fontWeight={800} fontSize={18}>
          {" "}
          Welcome !
        </Typography> */}
        <Typography mt={1} fontSize={14}>
          {" "}
          To complete and submit your application you would be required to
          upload digital copies of the following documents:
        </Typography>

        <ul className="  list-disc pl-10 my-4">
          <li>
            <Typography sx={{ fontSize: 12 }}>Passport Photography</Typography>
          </li>
          <li>
            <Typography sx={{ fontSize: 12 }}>Utility Bills</Typography>
          </li>
          <li>
            <Typography sx={{ fontSize: 12 }}>
              Means of ID - Valid Govt. Issued ID (Voters card, Intl. Passport,
              Drivers License)
            </Typography>
          </li>
          <li>
            <Typography sx={{ fontSize: 12 }}>Signature </Typography>
          </li>
        </ul>

        <Typography fontSize={14}>
          Please keep in mind that this form is only for individual accounts. To
          open other types of accounts, send an email to
          fcmbamcustomercare@fcmb.com
        </Typography>

        <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
          <Link
            href="https://www.instagram.com/accounts/login/?next=/fcmbassetmgt/"
            target="_blank"
          >
            <InstagramIcon sx={{ height: 30, width: 30 }} />
          </Link>
          <Link
            href="https://www.linkedin.com/company/fcmb-asset-management-limited/"
            target="_blank"
          >
            <LinkedInIcon sx={{ height: 30, width: 30 }} />
          </Link>
          <Link href="https://www.facebook.com/fcmbassetmgt" target="_blank">
            <FacebookIcon sx={{ height: 30, width: 30 }} />
          </Link>
          <Link href="https://twitter.com/fcmbassetmgt/" target="_blank">
            <XIcon sx={{ height: 30, width: 30 }} />
          </Link>
        </Box>
      </Box>
    </FormWrapper>
  );
}

export default PreRegisterInfo;
